export const deviceTypes = {
  HM5: "HM5",
  Imagyst: "Imagyst",
  QuickVet: "QuickVet Analyzer",
  SAUA: "SA_UA",
  VetscanSA: "SA",
  VetscanUA: "UA",
  VS2: "VetScan VS2",
  VSPro: "Abaxis VSpro",
  Vue: "VUE",
  iStat: "i-STAT",
  HMPLUS: "HMPLUS",
};
